import { useEffect, useRef } from "react";
import { Bold, Italic, Link2, List, Underline } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const TOOLS = [
  ["bold", Bold, "Fet"],
  ["italic", Italic, "Kursiv"],
  ["underline", Underline, "Understrek"],
  ["insertUnorderedList", List, "Punktliste"],
];

export const NoteEditor = ({ html, visible, onHtml, onVisible, hideToggle = false, testId = "note-editor" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== html) ref.current.innerHTML = html || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    ref.current && onHtml(ref.current.innerHTML);
  };

  const addLink = () => {
    const url = window.prompt("Lim inn lenke (https://...)");
    if (url && /^(https?:|mailto:|tel:)/i.test(url.trim())) exec("createLink", url.trim());
  };

  return (
    <div className="space-y-4">
      {!hideToggle && <label className="flex items-center justify-between gap-3 rounded-md border border-slate-200 bg-white px-4 py-3 cursor-pointer">
        <div>
          <div className="text-sm font-medium text-slate-900">Vis tekstfeltet under kalkulatoren</div>
          <div className="text-xs text-slate-500">Skjules også på nettsiden når denne er av</div>
        </div>
        <Switch checked={!!visible} onCheckedChange={onVisible} data-testid="note-visible-switch" />
      </label>}
      <div className={`rounded-md border border-slate-200 bg-white transition-opacity ${visible || hideToggle ? "" : "opacity-60"}`}>
        <div className="flex gap-1 border-b border-slate-100 p-1.5">
          {TOOLS.map(([cmd, Icon, label]) => (
            <button key={cmd} type="button" title={label} aria-label={label} onMouseDown={(e) => { e.preventDefault(); exec(cmd); }}
              className="p-2 rounded hover:bg-slate-100 text-slate-700 transition-colors" data-testid={`note-tool-${cmd}`}>
              <Icon className="w-4 h-4" />
            </button>
          ))}
          <button type="button" title="Lenke" aria-label="Lenke" onMouseDown={(e) => { e.preventDefault(); addLink(); }}
            className="p-2 rounded hover:bg-slate-100 text-slate-700 transition-colors" data-testid="note-tool-link">
            <Link2 className="w-4 h-4" />
          </button>
        </div>
        <div
          ref={ref}
          contentEditable
          suppressContentEditableWarning
          onInput={(e) => onHtml(e.currentTarget.innerHTML)}
          className="note-editor min-h-[110px] p-4 text-[15px] leading-relaxed outline-none focus:ring-2 focus:ring-sky-500/40 rounded-b-md"
          data-placeholder="Skriv tekst som vises under kalkulatoren…"
          data-testid={testId}
        />
      </div>
    </div>
  );
};
